import {type ActionTree} from 'vuex';

const actions: ActionTree<ICustomerState, RootState> = {
    fetchResourceData({
        commit,
        getters,
    }, {
        options = {},
    }: CustomerFetchDataOptions)
    {
        if (getters.fetched && getters.fetched >= Date.now() - 120_000)
        {
            return Promise.resolve();
        }

        let getPageOptions = {} as GetPageOptions;
        for (const optionsKey in options)
        {
            if (!options.hasOwnProperty(optionsKey))
            {
                continue;
            }

            getPageOptions[optionsKey] = options[optionsKey];
        }

        getPageOptions.url = '/customer/fetch-data';

        return this.dispatch('getPage', getPageOptions).then((response) =>
        {
            const data = response.data?.data;
            if (data)
            {
                commit('setData', data);
            }
        });
    },

};

export default actions;